/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {UsernamePanel} from "../ui/UsernamePanel";
import {VGap} from "../widget/VGap";
import {LogoutButton} from "../ui/LogoutButton";
import {StorageKey_UserEmail} from "@intuitionrobotics/user-account/frontend";

export function NoPermissionsPanel() {
	const email = StorageKey_UserEmail.get();
	return <div className={'ll_v_c match_width'} style={{backgroundColor: "#10296a"}}>
		<UsernamePanel text={email + " has no permissions"}/>
		<VGap v={20}/>
		<LogoutButton/>
	</div>;
}